// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-prefabpickeraccordion_container__rlfkw"};